
document.addEventListener('DOMContentLoaded', function(){

const overlay = document.getElementById('kbSearchOverlay');
const closeBtn = document.getElementById('kbSearchClose');

const triggerInput = document.querySelectorAll('.kb-trigger-search');

triggerInput.forEach(function(input){

input.addEventListener('click', function(e){
e.preventDefault();

overlay.classList.add('active');

document.documentElement.style.overflow='hidden';

document.body.classList.add('kb-search-open');

document.body.style.overflow='hidden';

setTimeout(()=>{

document.getElementById('kbSearchInput').focus();

},200);

});

});

closeBtn.addEventListener('click', function(){

overlay.classList.remove('active');

document.documentElement.style.overflow='';

document.body.classList.remove('kb-search-open');

document.body.style.overflow='';

});

const productTab = document.getElementById('kbProductTab');
const technicalTab = document.getElementById('kbTechnicalTab');
const techWrapper = document.getElementById('kbTechWrapper');
productTab.addEventListener('click', function(){

productTab.classList.add('active');
technicalTab.classList.remove('active');

techWrapper.classList.remove('active');

});

technicalTab.addEventListener('click', function(){

technicalTab.classList.add('active');
productTab.classList.remove('active');

techWrapper.classList.add('active');

});

document.querySelectorAll('.kb-tech-head').forEach(function(btn){

btn.addEventListener('click', function(){

const content = this.nextElementSibling;

content.classList.toggle('active');

if(content.style.display === 'block'){
content.style.display = 'none';
}else{
content.style.display = 'block';
}

});

});

});

/* =========================================
AUTO TECHNICAL NAME FETCH
========================================= */

const kbTechWrapper =
document.getElementById('kbTechWrapper');

if(kbTechWrapper){

fetch('/products.json?limit=250')
.then(res => res.json())
.then(data => {

const grouped = {};

/* LOOP PRODUCTS */

data.products.forEach(product => {

let technicalName = '';

/* PRIORITY */
/* TECHNICAL NAME LOGIC */

if (
product.tags &&
product.tags.length > 0
){

/* find technical: tag */

const technicalTag =
product.tags.find(tag =>
tag.toLowerCase().startsWith('technical:')
);

if(technicalTag){

technicalName =
technicalTag.replace(/technical:/i,'').trim();

}

}

/* fallback */

if(!technicalName){

technicalName = product.title;

}

/* REMOVE BRAND NAME */

technicalName = technicalName
.replace(/^krishikranti\s+/i,'')
.replace(/^krishibhandar\s+/i,'')
.replace(/^krishi\s+/i,'')
.trim();

/* CLEAN */

technicalName = technicalName.trim();

if(!technicalName) return;

const firstLetter =
technicalName.charAt(0).toUpperCase();

/* GROUP */

if(!grouped[firstLetter]){
grouped[firstLetter] = [];
}

grouped[firstLetter].push({
name: technicalName,
url: '/products/' + product.handle
});

});

/* SORT A-Z */

const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

let html = '';

letters.forEach(letter => {

const items = grouped[letter] || [];

html += `

<div class="kb-tech-group">

<div class="kb-tech-letter">

<span>${letter}</span>

<span>+</span>

</div>

<div class="kb-tech-items">

${items.length ? items.map(item => `

<a href="${item.url}"
class="kb-tech-item">

${item.name}

</a>

`).join('') :

`<div class="kb-tech-item">
No Technical Names
</div>`}

</div>

</div>

`;

});

kbTechWrapper.innerHTML = html;

/* ACCORDION */

document
.querySelectorAll('.kb-tech-letter')
.forEach(btn => {

btn.addEventListener('click', function(){

const parent =
this.parentElement;

parent.classList.toggle('active');

});

});

});

}


/* =========================================
LIVE PRODUCT SEARCH
JSON TECHNICAL SEARCH
========================================= */

document.addEventListener('DOMContentLoaded', function(){

const searchInput =
document.getElementById('kbSearchInput');

const productResults =
document.getElementById('kbProductResults');

/* Text suggestions disabled */
const suggestionBox = null;

const productTab =
document.getElementById('kbProductTab');

const technicalTab =
document.getElementById('kbTechnicalTab');

const techWrapper =
document.getElementById('kbTechWrapper');

if(
!searchInput ||
!productResults
){
return;
}

let allProducts = [];

let technicalMappings = [];

/* =========================================
FETCH SHOPIFY PRODUCTS
========================================= */

fetch('/products.json?limit=250')
.then(res => res.json())
.then(data => {

allProducts = data.products || [];

});

/* =========================================
FETCH JSON
========================================= */

fetch('/assets/technical-products.json')
.then(res => res.json())
.then(data => {

technicalMappings = data || [];

})
.catch(error => {

console.log(
'Technical JSON Error',
error
);

});

/* =========================================
SEARCH
========================================= */

searchInput.addEventListener('input', function(){

const value =
this.value.toLowerCase().trim();

/* PRODUCT TAB ACTIVE */

if(productTab.classList.contains('active')){

productResults.classList.add('active');

productResults.style.display = 'block';

techWrapper.classList.remove('active');

}

/* EMPTY */

if(value === ''){

productResults.innerHTML = '';

productResults.classList.remove('active');

return;

}

let matchedProducts = [];

/* =========================================
TECHNICAL JSON MATCH
========================================= */

technicalMappings.forEach(map => {

  const technicalName =
    (map.technical_name || '')
      .toLowerCase()
      .trim();

  // Sirf technical name match
  if (!technicalName.includes(value)) {
    return;
  }

  // Technical record ke keywords se actual product find karo
  allProducts.forEach(product => {

    const title =
      (product.title || '')
        .toLowerCase();

    const found =
      (map.product_keywords || []).some(keyword =>
        title.includes(
          keyword.toLowerCase()
        )
      );

    if (found) {

      matchedProducts.push({
        product,
        score: 1000
      });

    }

  });

});

/* =========================================
NORMAL PRODUCT SEARCH
========================================= */

allProducts.forEach(product => {

  const title =
    (product.title || '')
      .toLowerCase();

  if (
    title.includes(value)
  ) {

    matchedProducts.push({

      product,
      score: 100

    });

  }

});

/* SORT */

matchedProducts.sort(
  (a,b)=>
  b.score-a.score
);

/* UNIQUE */

const uniqueProducts = [];

const usedHandles = [];

matchedProducts.forEach(item => {

if(
!usedHandles.includes(
item.product.handle
)
){

usedHandles.push(
item.product.handle
);

uniqueProducts.push(
item.product
);

}

});

/* =========================================
SUGGESTIONS
========================================= */

/* Text suggestions disabled */

/* NO RESULTS */

if(uniqueProducts.length === 0){

productResults.innerHTML = `

<div class="kb-no-results">
No products found
</div>

`;

return;

}

/* =========================================
HTML
========================================= */

let html = '';

uniqueProducts
.slice(0,20)
.forEach(product => {

html += `

<a
href="/products/${product.handle}"
class="kb-product-card"
>

<div class="kb-product-image">

<img
src="${product.images[0]?.src || ''}"
alt="${product.title}"
loading="lazy"
>

</div>

<div class="kb-product-info">

<div class="kb-product-title">
${product.title}
</div>

<div class="kb-product-price">
₹${product.variants[0]?.price || '0'}
</div>

</div>

</a>

`;

});

productResults.innerHTML = html;

});

/* =========================================
PRODUCT TAB
========================================= */

productTab.addEventListener('click', function(){

searchInput.removeAttribute('readonly');

searchInput.style.opacity = '1';

productResults.classList.add('active');

techWrapper.classList.remove('active');

});

/* =========================================
TECHNICAL TAB
========================================= */

technicalTab.addEventListener('click', function(){

productResults.classList.remove('active');

productResults.innerHTML = '';

productResults.style.display = 'none';

searchInput.value = '';

// searchInput.setAttribute('readonly', true);

// searchInput.style.opacity = '0.6';

});

});

/* =========================================
PREMIUM VOICE SEARCH
========================================= */

document.addEventListener('DOMContentLoaded', function(){

const micBtn =
document.getElementById('kbMicBtn');

const searchInput =
document.getElementById('kbSearchInput');

const productTab =
document.getElementById('kbProductTab');

const technicalTab =
document.getElementById('kbTechnicalTab');

const techWrapper =
document.getElementById('kbTechWrapper');

const productResults =
document.getElementById('kbProductResults');

/* SUPPORT CHECK */

const SpeechRecognition =
window.SpeechRecognition ||
window.webkitSpeechRecognition;

if(!SpeechRecognition){

micBtn.style.display = 'none';

return;

}

/* INIT */

const recognition =
new SpeechRecognition();

recognition.lang = 'en-IN';

recognition.continuous = false;

recognition.interimResults = true;

/* CLICK */

micBtn.addEventListener('click', function(){

/* ACTIVE EFFECT */

micBtn.classList.add('listening');

recognition.start();

});

/* LIVE LISTEN */

recognition.onresult = function(event){

const transcript =
event.results[0][0].transcript;

/* CLEAN VOICE */

const cleanTranscript =
transcript
.toLowerCase()
.replace(/\s+/g,' ')
.trim();

/* SET INPUT */

searchInput.value =
cleanTranscript;

/* =========================================
PRODUCT SEARCH MODE
========================================= */

if(productTab.classList.contains('active')){

searchInput.dispatchEvent(
new Event('input')
);

}

/* =========================================
TECHNICAL SEARCH MODE
========================================= */

if(technicalTab.classList.contains('active')){

const allGroups =
document.querySelectorAll('.kb-tech-group');

/* RUN NORMAL SEARCH */

searchInput.dispatchEvent(
new Event('input')
);

}

};

/* END */

recognition.onend = function(){

micBtn.classList.remove('listening');

};

/* ERROR */

recognition.onerror = function(){

micBtn.classList.remove('listening');

};

});
